// extracted by mini-css-extract-plugin
export default {"container":"SessionPresenters_container__NOiwf","list":"SessionPresenters_list__aPZXJ","heading":"SessionPresenters_heading__1ySSA"};